import { Store } from 'redux'
import { getFormValues } from 'redux-form'

import { FORM_NAME as filterForm } from '@cinch/oxd-containers/listing-filters/src'
import { customEventNames, updateVehicleFilters } from '@cinch/oxd-utils/analytics/src'

export default function (store: Store): Cinch.AnalyticsEvent<Cinch.FilterFormData> {
  const reduxStore = store.getState()
  const filterValues: Cinch.FilterFormData = getFormValues(filterForm)(reduxStore)

  delete filterValues.cid
  delete filterValues.icid

  const { town, postcode } = reduxStore.profile.data
  const values = { ...filterValues, town, postcode }

  updateVehicleFilters(values)

  return {
    name: customEventNames.vehicleListing,
    details: values,
  }
}
